export const useIsEco = () => {
  const isEco = window.env.CUSTOMS_REACTJS_DASHBOARD_ECO;

  return { isEco }
}